<template>
  <div class="flex flex-col py-4">
    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
      <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400">
        <div>
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >M1</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >M1 Koment</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >BZ</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >BZ Koment</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >M3</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
                >M3 Koment</th>
                <th class="px-2 py-2 border border-gray-400 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">
                    <div v-if="ratings.m1 === '0'">0</div>
                    <div v-if="ratings.m1 === '+'">+</div>
                    <div v-if="ratings.m1 === 'M'">M</div>
                  </div>
                </td>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">{{ ratings.comment_m1 }}</div>
                </td>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">
                    <div v-if="ratings.bz === '0'">0</div>
                    <div v-if="ratings.bz === '+'">+</div>
                    <div v-if="ratings.bz === 'M'">M</div>
                  </div>
                </td>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">{{ ratings.comment_bz }}</div>
                </td>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">
                    <div v-if="ratings.m3 === '0'">0</div>
                    <div v-if="ratings.m3 === '+'">+</div>
                    <div v-if="ratings.m3 === 'M'">M</div>
                  </div>
                </td>
                <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <div class="flex items-center">{{ ratings.comment_m3 }}</div>
                </td>
                <td v-if="this.graded" class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                  <router-link :to="{ name: 'edit-ratings', params: { id: ratings.id } }">
                    <span
                      class="text-indigo-600 hover:text-indigo-900 font-semibold focus:outline-none focus:underline"
                    >Ndrysho</span>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >M1</th>
              <th
                class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >BZ</th>
              <th
                class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >M3</th>
              <th
                class="px-2 py-2 border border-gray-400 bg-gray-50 text-left font-bold text-xs leading-4 text-gray-800 uppercase tracking-wider"
              >TOTALI</th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr>
              <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                <div class="flex items-center">{{ ratingsTotal.m1 }}</div>
              </td>
              <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                <div class="flex items-center">{{ ratingsTotal.bz }}</div>
              </td>
              <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                <div class="flex items-center">{{ ratingsTotal.m3 }}</div>
              </td>
              <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">
                <div class="flex items-center">{{ ratingsTotal.totali }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    date: String,
    user: Number
  },
  data() {
    return {
      ratingsTotal: {},
      ratings: {},
      id: this.$route.params.id,
      graded: false
    };
  },
  created() {
    this.getRatings();
  },
  computed: {
    getDate() {
      return this.date;
    },
    getUserId() {
      return this.user;
    }
  },
  watch: {
    date: function() {
      this.getRatings();
    },
    user: function() {
      this.getRatings();
    }
  },
  methods: {
    getRatings() {
      if (this.user) {
        axios
          .get(
            `${process.env.VUE_APP_API}/excel/vlersimet?day=${this.date}&user_id=${this.user}`
          )
          .then(response => {
            // console.log(response);
            this.ratingsTotal = response.data.deriSot;
            this.ratings = response.data.sot;
            this.graded = response.data.deriSot.vleresuar;
            // console.log(`graded ${this.graded}`);
          })
          .catch(error => console.log(error));
      } else {
        axios
          .get(`${process.env.VUE_APP_API}/excel/vlersimet?day=${this.date}`)
          .then(response => {
            // console.log(response);
            this.ratingsTotal = response.data.deriSot;
            this.ratings = response.data.sot;
            this.graded = response.data.deriSot.vleresuar;
            // console.log(`graded ${this.graded}`);
          })
          .catch(error => console.log(error));
      }
    }
  }
};
</script>

<style>
</style>